/**
 * Identidade Makila (pacote de logótipo em img/logo, Ribeiro Tecnologias e Serviços):
 * símbolo = recibo branco com "M" vermelho sobre quadrado arredondado #A6070C.
 * Cores: vermelho #A6070C, grafite #3A3A3B, preto #111111. Tipo: Poppins.
 *
 * O logótipo completo vem dos SVG oficiais em /brand (texto já em curvas);
 * o símbolo é desenhado aqui para poder ser usado em qualquer tamanho sem pedido extra.
 */
export const BRAND = { red: '#A6070C', graphite: '#3A3A3B', black: '#111111' } as const;

/** Símbolo (app icon). Abaixo de ~32 px o recibo perde detalhe — usa-se `simple`. */
export function MakilaMark({ className, simple = false }: { className?: string; simple?: boolean }) {
  if (simple) {
    return (
      <svg viewBox="0 0 512 512" className={className} role="img" aria-label="Makila">
        <rect width="512" height="512" rx="112" fill={BRAND.red} />
        <path d="M136 372 L136 150 L234 268 L376 128 L376 372" fill="none" stroke="#fff" strokeWidth="74" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 512 512" className={className} role="img" aria-label="Makila">
      <rect width="512" height="512" rx="116" fill={BRAND.red} />
      <path d="M132 120Q132 92 160 92L352 92Q380 92 380 120L380 404L359.3 430L338.7 404L318 430L297.3 404L276.7 430L256 404L235.3 430L214.7 404L194 430L173.3 404L152.7 430L132 404Z" fill="#fff" />
      <path d="M178 300L178 160L238 236L334 132L334 300" fill="none" stroke={BRAND.red} strokeWidth="40" strokeLinecap="round" strokeLinejoin="round" />
      <rect x="178" y="336" width="156" height="14" rx="7" fill={BRAND.graphite} />
      <rect x="178" y="364" width="96" height="14" rx="7" fill={BRAND.graphite} />
      <rect x="292" y="364" width="42" height="14" rx="7" fill={BRAND.red} />
    </svg>
  );
}

/**
 * Logótipo horizontal oficial (símbolo + "Makila" + "FACTURAÇÃO" + assinatura).
 * `tone="dark"` para fundos escuros (versão negativa). Largura mínima: 140 px.
 */
export function MakilaLogo({ className, tone = 'light' }: { className?: string; tone?: 'light' | 'dark' }) {
  const src = tone === 'dark' ? '/brand/makila-horizontal-negativo.svg' : '/brand/makila-horizontal-cor.svg';
  return <img src={src} alt="Makila Facturação" className={className} width={866} height={316} decoding="async" />;
}
